<div mat-dialog-title *ngIf="showTitle"><h4 i18n="@@prompt-refresh-dialog-header">An error has occurred</h4></div>
<mat-dialog-content>
    <p i18n="@@prompt-refresh-dialog-text">It seems like the page has been idle too long, please refresh to continue.</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="warn" class="mr-3 primary-contrast-color" (click)="refresh()" i18n="@@prompt-refresh-dialog-refresh-btn">Refresh</button>
    <button mat-button mat-flat-button class="subtle-button-color" mat-dialog-close i18n="@@confirm-dialog-cancel">Cancel</button>
</mat-dialog-actions>
